function normalize(str) {
  if (str) {
    let string = str.replace(/\W/g, '-').replace(/-+/g, '-').toLowerCase();
    return string;
  }
}

export default normalize;
